import React from 'react';
import classes from './style.module.scss';
import promoBeer from '../../media/promoBeer.png';
import Footer from '../Footer/Footer';

const Promo = () => {
    const tableInfo = {
        name: 'Сумма накоплений на карте, руб. и процент возвращаемых бонусов',
        tableText: [
            'от 100 до 24 999 руб. - 5%',
            'от 25 000 до 49 999 руб. - 7%',
            'от 50 000 до 99 999 руб. - 10%',
            'от 100 000 до 199 999 руб. - 15%',
            'от 200 000 рублей и более - 20%',
        ],
    };

    const visiterCard1 = {
        name: 'Карта гостя Бильярдного Клуба «Легенда»',
        info: [
            {
                name: 'Получение Карты гостя',
                text: 'Карта гостя приобретается гостями БК Легенда по сумме номинальных бонусных рублей на ее счете (100 рублей), либо как подарочный вариант с произвольной суммой (1000 рублей, 5000 рублей и т.д.).\nОбязательным условием получения Карты гостя является заполнение анкеты постоянного гостя.',
            },
            {
                name: 'Бонусная система',
                text: 'Наша бонусная система работает просто: за каждый произведенный заказ нашим гостям начисляются бонусы, которые можно использовать для оплаты будущих покупок. Чем больше заказов вы делаете, тем больше бонусов вы получаете. Бонусы можно использовать для оплаты до 100% от стоимости заказа. Бонусная система является накопительной, согласно таблице:',
            },
        ],
    };

    const visiterCard2 = [
        {
            name: 'Акции по Карте гостя',
            text: [
                'Каждую среду – ',
                'Клубный день. ',
                'Скидка 40% на игру на бильярде дополнительно к Бонусам всем держателям Карты гостя с 12.00 до 00.00 часов (необходимо закрыть заказ и предоставить Карту гостя до 23.59).',
                'Каждый понедельник – ',
                'Женский день. ',
                'Скидка 40% на игру на бильярде  дополнительно к Бонусам всем девушкам держателям Карты гостя с 12.00 до 00.00 часов (необходимо закрыть заказ и предоставить Карту гостя до 23.59).',
                'День рождения',
                '– скидка 10% на игру на бильярде, бар и кухню держателям Карты гостя в День Рождения, 5 дней до Дня Рождения и 5 дней после Дня Рождения.',
            ],
        },
        {
            name: 'Льготные Карты гостя.',
            text: 'Лицам до 18 и старше 60 лет, либо по предъявлению пенсионного удостоверения предоставляются скидки 40% на игру на бильярде дополнительно к Бонусам с 12.00 до 00.00 часов (необходимо закрыть заказ и предоставить Карту гостя до 23.59).',
        },
    ];

    return (
        <div className={classes.page}>
            <div className={classes.container}>
                <div className={classes.promoContainer}>
                    <div>
                        <h3 className={classes.title}>{visiterCard1.name}</h3>
                        {visiterCard1.info.map((item, index) => (
                            <div key={index}>
                                <h4 className={classes.sectionTitle}>
                                    {item.name}
                                </h4>
                                <p className={classes.sectionText}>
                                    {item.text}
                                </p>
                            </div>
                        ))}
                        <div className={classes.table}>
                            <h4 className={classes.sectionTitle}>
                                {tableInfo.name}
                            </h4>
                            {tableInfo.tableText.map((item, index) => (
                                <p key={index} className={classes.sectionText}>
                                    {item}
                                </p>
                            ))}
                        </div>
                        {visiterCard2.map((item, index) => (
                            <div key={index}>
                                <h3 className={classes.sectionTitle}>
                                    {item.name}
                                </h3>
                                <p className={classes.sectionText}>
                                    {item.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className={classes.promoContainer}>
                    <div>
                        <img
                            className={classes.promoBeer}
                            src={promoBeer}
                            alt="promoBeer"
                        />
                        <p className={classes.promoBeerText}>
                            При покупке двух разливных напитков третий напиток в
                            подарок!
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Promo;
